module.exports = __webpack_public_path__ + "img/titles6.ba64028c.png";